var map = {
	"./daem.jpeg": "BWtv",
	"./marketing-wp.jpeg": "L1fk",
	"./phishing.png": "o5ks",
	"./pwc-whitepaper.jpeg": "DI5D",
	"./technical-wp.jpeg": "mk00"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dx9n";